var map = {
	"./arrow-right_purple.svg": "daf4",
	"./arrow-right_teal.svg": "a928",
	"./casana/animatedSVG.svg": "0eb2",
	"./casana/casana-modal_720p.mp4": "e00f",
	"./casana/casana-modal_720p.webm": "91b6",
	"./casana/casana-page-layout.jpg": "10ac",
	"./casana/casana-scroll2_720p.mp4": "758e",
	"./casana/casana-scroll2_720p.webm": "1313",
	"./close.svg": "bf37",
	"./dad/dad-card-game-detail_optimized.mp4": "d327",
	"./dad/dad-card-game-detail_optimized.webm": "50a5",
	"./dad/dad-hero.jpg": "9562",
	"./dad/dad-mobile-details.jpg": "b437",
	"./dad/dad-slider-detail.jpg": "3180",
	"./dattocon/atalanta-hompage.jpg": "6485",
	"./dattocon/dattocon-homepage.jpg": "3b15",
	"./dattocon/dattocon-speakers-detail.jpg": "87bd",
	"./dattocon/paris-screen-video.mp4": "f863",
	"./dattocon/paris-screen-video.webm": "8633",
	"./drsugi/Screen-Shot-2017-04-17-at-3.37.02-PM.jpg": "598a",
	"./drsugi/Screen-Shot-2017-09-06-at-6.57.58-PM.jpg": "7115",
	"./drsugi/icons.svg": "7b5c",
	"./drsugi/pageMobile.png": "3110",
	"./fonts/Righteous/OFL.txt": "ff29",
	"./fonts/Righteous/Righteous-Regular.ttf": "f681",
	"./github-logo.svg": "4766",
	"./instagram-logo.svg": "13f5",
	"./launchable/launchable-detail1_720p4.mp4": "3476",
	"./launchable/launchable-detail1_720p4.webm": "d509",
	"./launchable/launchable-detail3.mp4": "9d22",
	"./launchable/launchable-detail3.webm": "3564",
	"./linkedin-logo.svg": "be3b",
	"./og_image.jpg": "c919",
	"./scroll.svg": "d4cd",
	"./yir2017/icons-detail.mp4": "23b8",
	"./yir2017/icons-detail.webm": "5652",
	"./yir2017/yir-2017-detail.jpg": "053e",
	"./yir2017/yir-2017-detail2.jpg": "7a95",
	"./yir2017/yir2017-3_720p.mp4": "ff5d",
	"./yir2017/yir2017-3_720p.webm": "cd46",
	"./yir2018/yir-2018-detail.jpg": "0a3b",
	"./yir2018/yir-2018-detail2.jpg": "32a6",
	"./yir2018/yir-2018-detail3.jpg": "cfca",
	"./yir2018/yir-short.webm": "042b",
	"./yir2018/yir-short2.mp4": "5995",
	"./yir2018/yir-short2.webm": "7673",
	"./yir2018/yir-short_optimized.mp4": "8a2c",
	"./zoom.svg": "34c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";